import { render, staticRenderFns } from "./StockMovementList.vue?vue&type=template&id=2110259b&"
import script from "./StockMovementList.vue?vue&type=script&lang=js&"
export * from "./StockMovementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockMovementList.vue"
export default component.exports